export default (state = {}, action) => {
	switch (action.type) {
		case "IS_LOADING":
			state = action.loading;
			return state;
		default:
			return state;
	}
};
